module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more darker moved-right"
  }, [_c('h6', {
    staticClass: "d-flex align-items-center dark pointer m-2 d-flex align-items-center",
    staticStyle: {
      "padding-bottom": "0.0px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v("Go to Filters")])]), _vm._v(" "), (_vm.getIsloadingSelectedEvent) ? _c('div', {
    staticClass: "d-flex flex-column align-items-center pt-5 p-3 text-center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Loading Event")]), _vm._v(" "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : (_vm.event) ? _c('div', {
    staticClass: "relative mt-3 mx-1 border-right-light border-bottom-light border-left-light"
  }, [_c('div', {
    staticClass: "box border-top-light shadowless"
  }, [_c('div', {
    staticClass: "wrapper px-4"
  }, [(_vm.event.nameAlias) ? _c('div', [(_vm.product) ? _c('span', [_vm._v(_vm._s(_vm.product.name))]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('h3', [_vm._v(_vm._s(_vm.event.nameAlias))]) : _vm._e()]) : (_vm.product) ? _c('h3', [_vm._v(_vm._s(_vm.product.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [(_vm.event.shareType === 2) ? _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Virtual Roster'),
      expression: "'Virtual Roster'"
    }],
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("@/assets/images/badges/badge_vr.svg"),
      "alt": "Virtual Roster"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.event.availabilityType == 2 && _vm.event.shareType == 1) ? _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Shared Availability - Resource are shared with more activities'),
      expression: "'Shared Availability - Resource are shared with more activities'"
    }],
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("@/assets/images/badges/badge_sa.svg"),
      "alt": "Shared Availability"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.event.hasCutOff == true && _vm.event.softCutOff == true) ? _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Soft Cutoff'),
      expression: "'Soft Cutoff'"
    }],
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("@/assets/images/badges/badge_sc.svg"),
      "alt": "Soft Cutoff"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.event.hasCutOff == true && _vm.event.softCutOff == false) ? _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Cutoff'),
      expression: "'Cutoff'"
    }],
    staticStyle: {
      "height": "20px"
    },
    attrs: {
      "src": require("@/assets/images/badges/badge_hc.svg"),
      "alt": "Cutoff"
    }
  }) : _vm._e()]), _vm._v(" "), _c('links', {
    attrs: {
      "event": _vm.event
    }
  })], 1)]), _vm._v(" "), _c('tabs-place', {
    attrs: {
      "event": _vm.event
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6f1187f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f1187f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventMore.vue
// module id = 2671
// module chunks = 0